// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zb_MZ","container__image":"styles_container__image__nPm5Z","social-media-link-wrapper":"styles_social-media-link-wrapper__2Pd27"};